const overviewLinks = {
  root: () => '/overview',
};

export default overviewLinks;
